/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/react-in-jsx-scope */
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import {
    ViewModelForm,
    ViewModelServiceContext,
    withViewModelService
} from '@xengage/gw-portals-viewmodel-react';
import {useContext,useEffect,useState,useCallback} from 'react';
import { withRouter } from 'react-router-dom';
import { GooglePlacesLookupComponent } from 'cpmi-capability-googleplaces-react';
import { messages as commonMessages } from '@xengage/gw-platform-translations';
import { ModalNextContext } from '@jutro/components';
import { LoaderExt } from 'gw-components-platform-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import _ from 'lodash';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { BreakpointTrackerContext } from '@jutro/layout';
import CertificateService from 'cpmi-capability-certificate/services/CertificateService';
import messages from './EditCertificate.messages';
import metadata from './EditCertificate.metadata.json5';
import styles from './EditCertificate.module.scss';
import usecpmiAnalytics from '../../../hooks/usecpmiAnalytics'
import useGoogleAnalytics from '../../../hooks/useGoogleAnalytics';


import { CheckboxGroupField } from '@jutro/legacy/components';


function EditCertificate(props) {
    const {
        id,
        history: {
            location: {
                state
            },
        },history
    } = props;
    const [isLoading, setIsLoading] = useState(false);
    const ModalNext=useContext(ModalNextContext);
    const breakpoint = useContext(BreakpointTrackerContext);
    const certificateInfo=props?.history?.location?.state?.data;
    const { authHeader } = useAuthentication();
    const [certPolicyPeriodSummary, setCertPolicyPeriodSummary] = useState();
    const { isComponentValid ,registerComponentValidation} = useValidation('CreateCertificatePage');
    const [trackPageView] = usecpmiAnalytics()
    const [trackGAPageView] = useGoogleAnalytics();


    // const[policyPeriodData,setPolicyPeriodData]=useState([]);

    const viewModelService = useContext(ViewModelServiceContext);

    useEffect(() => {
        trackPageView("Edit Certificate", "/certificate/edit")
    },[])

    useEffect(() => {
        trackGAPageView("/certificate/edit","Edit Certificate")
    },[])

    useEffect(()=>{

        const policyResult=props?.location?.state?.data;
        const data=[policyResult?.policyNumber,policyResult?.periodId]


        setIsLoading(true);
        CertificateService.getCertPolicyPeriod(data, authHeader)
            .then((result) => {
                
                setCertPolicyPeriodSummary(result);
                setIsLoading(false)
            })

    },[])


    const certviewmodel = viewModelService.create(
        certificateInfo,
        'pc',
        'edge.capabilities.cpmi.certificate.dto.CertTemplateDto'
    );
    // const certviewmodel = viewModelService.create(
    //     {},
    //     'pc',
    //     'edge.capabilities.cpmi.certificate.dto.CertTemplateDto'
    // );
    const [createCertificateVM, setCreateCertificateVM] = useState(
        certviewmodel
    );
    
    // const [toggleValue, setToggleValue] = useState(false)

    useEffect(() => {
        registerComponentValidation(() => {
            return createCertificateVM?.holder?.address?.aspects?.valid && createCertificateVM?.holder?.address?.aspects?.subtreeValid;
        });
    }, [createCertificateVM?.holder?.address?.aspects?.subtreeValid, createCertificateVM?.holder?.address?.aspects?.valid, registerComponentValidation]);
 

    const renderOffdutyOfficer = useCallback((value) => {
        value === 'yes' ? true : false;
        publish('JUTRO_TOPICS.BUTTON_CLICKED', 'JUTRO_TOPICS.VALUE_CHANGED', 'JUTRO_TOPICS.FIELD_BLUR', {
            path: '/certificate/create/policyNo,pcrint:id',
            title: 'Create Certificate of Insurance'
        });
    },[])

    const handleClick = useCallback(
        (e, item, index, value) => {
            _.set(createCertificateVM.value, `classCodes`, [item.compositeKey]);
        },
        [createCertificateVM]
    );

    const getClassCodes = useCallback(
        (policyperiod) => {
            if(certPolicyPeriodSummary!==undefined)
            {
                return Object.entries(policyperiod.classCodesByState).map(
                    ([key, value]) => {
                        let classcodes=""
                        return (
                            <>
                               
                                <CheckboxGroupField
                                    availableValues={
                                        value.map((item) => {
                                            classcodes=item.compositeKey
                                            return {
                                                code:item.compositeKey,
                                                name:`${item.code} - ${item.shortDesc}`
                                            }
                                        })
                                    }
                                    id="checkbox-group-field"
                                    path="classCodes"
                                    label={key}
                                    onBlur={function noRefCheck() {}}
                                    onFocus={function noRefCheck() {}}
                                    onValidationChange={function noRefCheck() {}}
                                    onValueChange={writeValue}
                                    resolveValue={readValue}
                                    value={createCertificateVM?.classCodes?.value || createCertificateVM?.classCodes}
                                    labelClassName={styles.labelNmae}
                                    className={styles.labelSeperator}
                                />
                            </>
                        );
                    }
                );
            }
            

            
        },
        [certPolicyPeriodSummary, createCertificateVM?.classCodes]
    );

    const cancelChange = useCallback(() => {
        ModalNext.showConfirm({
            title: messages.cancelChangeTitle,
            message: messages.cancelChangeMessage,
            status: 'info',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.yesModel,
            cancelButtonText: commonMessages.noModel,
        }).then((results) => {
            if (results === 'confirm') {
                history.go(-1);
            }
        }, _.noop);
    }, [ModalNext, history]);

    const saveCertificate = useCallback(() => {
        _.set(createCertificateVM,'policyNumber',props?.history?.location?.state?.data?.policyNumber)
        _.set(createCertificateVM,'periodId',props?.history?.location?.state?.data?.periodId)
        
        setIsLoading(true);
        CertificateService.updateCertificate([createCertificateVM.value], authHeader)
            .then((res) => {
                return history.push(`/certificate/${props?.match?.params?.selectedPolicy}/${props?.match?.params?.termPublicId}/list`)
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, [createCertificateVM, props,authHeader, history]);

    const writeValue = useCallback(
        (value, path) => {
            const newCreateCertificateVM = viewModelService.clone(createCertificateVM);
            _.set(newCreateCertificateVM, path, value);
            setCreateCertificateVM(newCreateCertificateVM);
        },
        [createCertificateVM, viewModelService]
    );

    const certificateData = createCertificateVM.value;
     
    const readValue = useCallback(
        (id, path) => {
            return readViewModelValue(
                metadata.componentContent,
                createCertificateVM,
                id,
                path,
                overrides
            );
        },
        [createCertificateVM]
    );

    const getInsuredAvailableValues = () => {
        const namedInsuredArray = [];
        
        if(certPolicyPeriodSummary!==undefined)
        {
            certPolicyPeriodSummary.namedInsureds.map((item) => {
                namedInsuredArray.push({
                    code: item,
                    name: item,
                });
            });
    
            return namedInsuredArray;

        }
        
       

       
    };

    
    const setDisabled = useCallback(()=> {
        
        if(!_.isEmpty(_.get(createCertificateVM.value,'holder.name')) && 
        !_.isEmpty(_.get(createCertificateVM.value,'displayName')) && 
        isComponentValid &&
         _.get(createCertificateVM.value,'classCodes').length>0
        )
        {
            return false;
        }
        return true;
    },[createCertificateVM.value, isComponentValid]);

    const getPolicyNumber=(()=>{
        if(certPolicyPeriodSummary!==undefined)
        {
            return certPolicyPeriodSummary.policyPeriodDto.policyNumber;
        }
    })

    if (isLoading) {
        return <LoaderExt loaded={!isLoading} />;
    }


    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrides = {
        '@field': {
            labelPosition: breakpoint === 'tablet' ? 'top' : 'left',
            phoneWide: {
                labelPosition: 'top'
            }
        },
        policyNum: {
            // value: certPolicyPeriodSummary.policyPeriodDto.policyNumber,
            value:getPolicyNumber()
        },
        namedinsured: {
            availableValues: getInsuredAvailableValues(),
        },
        classCodes: {
            content: getClassCodes(certPolicyPeriodSummary),
        },
        save: {
            disabled: setDisabled()
        },
        COIgoogleplaces: {
            visible: true,
        },
        WaiverofSubrogation:{
            visible:certPolicyPeriodSummary?.waiverOfSubAllowed && certPolicyPeriodSummary.waiverOfSubAllowed===true
        },

        offdutypoliceofficer:{
            showRequired:false
        },
        actionsContainer1:{
            visible:false
        }

    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {
            googleplaces: GooglePlacesLookupComponent,
        },
        resolveCallbackMap: {
            cancelChange,
            writeValue,
            renderOffdutyOfficer,
            saveCertificate
        },
    };


    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={createCertificateVM}
            overrideProps={overrides}
            onValueChange={writeValue}           
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
            callbackMap={resolvers.resolveCallbackMap}
          
        />
    );
    
}

export default withRouter(withViewModelService(EditCertificate));